module.exports = __webpack_public_path__ + "img/admin_panel_settings_black_24dp.0679afc9.svg";